var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-menu',{attrs:{"text":_vm.text,"values":_vm.values},model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }